if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        const prevButton = this.querySelector('.product-media-modal__arrow--prev');
        const nextButton = this.querySelector('.product-media-modal__arrow--next');
        if (prevButton) prevButton.addEventListener('click', this.showPreviousMedia.bind(this));
        if (nextButton) nextButton.addEventListener('click', this.showNextMedia.bind(this));

        this.querySelectorAll('.product-media-modal__dot').forEach((dot) => {
          dot.addEventListener('click', () => this.showActiveMedia(dot.getAttribute('data-media-id')));
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(this.openedBy.getAttribute('data-media-id'));
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      showPreviousMedia() {
        const mediaItems = this.getMediaItems();
        const currentIndex = mediaItems.findIndex((item) => item.classList.contains('active'));
        const previousIndex = (currentIndex - 1 + mediaItems.length) % mediaItems.length;
        this.showActiveMedia(mediaItems[previousIndex].getAttribute('data-media-id'));
      }

      showNextMedia() {
        const mediaItems = this.getMediaItems();
        const currentIndex = mediaItems.findIndex((item) => item.classList.contains('active'));
        const nextIndex = (currentIndex + 1) % mediaItems.length;
        this.showActiveMedia(mediaItems[nextIndex].getAttribute('data-media-id'));
      }

      showActiveMedia(mediaId) {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        this.querySelectorAll('.product-media-modal__dot').forEach((dot) => {
          dot.classList.toggle('active', dot.getAttribute('data-media-id') === mediaId);
        });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
